import logo from './logo.svg';

import { Alert, Badge, Button, Card, Col, DatePicker, Divider, Popover, Row, Segmented, Skeleton, Space, Statistic, Tabs, Tooltip, Typography } from 'antd';
import ConfTimesChart from './components/ConfTimes';
import { useCallback, useEffect, useState } from 'react';
import ConfViolin from './components/ViolinPlot';
import LastTxConf from './components/LastTxConf';
import GaugeCPS from './components/GaugeCPS';
import FAQ from './components/FAQ';
import { Liquid } from '@ant-design/charts';
import BoxPlot from './components/BoxPlot';
import { AVAILABLE_PERIODS, fetcher, fetcherWS, getMsColor, msFormatter, useWindowDimensions } from './utils';
import prettyMilliseconds from 'pretty-ms';
import Appx from './components/MainTabs';
import Percentiles from './components/main/Percentiles';
import VsBTC from './components/main/VsBTC';
import {
  PercentageOutlined, BoxPlotOutlined, LineChartOutlined, ShareAltOutlined, TableOutlined, FieldTimeOutlined, DashboardOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons'
import StatsLive from './components/StatsLive';
import useSWR, { preload } from 'swr'
import TableConfs from './components/main/TableConfs';
import CPSBPSChart from './components/CPSBPSChart';
import useLastConfTime from './components/useLastConfTime';
// import TableBucket from './components/main/TableBucket';
const { Countdown } = Statistic;

function Home() {
  // const { data, error, isLoading } = useSWR(`/conf-times-table?page=${pageIndex}&limit=${pageSize}`, fetcher)
  const { data: dataAvgDay, isLoading: isLoadingAvgDay } = useSWR(`/conf-times?period=all`)
  const { lastConfTime } = useLastConfTime();
  const last7NotNull = dataAvgDay?.filter((d) => d.ts > 0).slice(-7);
  const last7Avg = last7NotNull?.reduce((acc, curr) => acc + curr.ts, 0) / last7NotNull?.length;
  const last1dAvg = last7NotNull?.[last7NotNull?.length - 2]?.ts; // -2 to avoid current day which is not complete yet
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // height: 'calc(100vh - 46px)',
    }}>

<div >
<Typography.Title
  level={2}
  className="title"
  id="title"
style={{
  // color: 'rgba(255, 255, 255, 0.90)',
  marginBottom: 32,
  textAlign: 'center',
}}>
 Nano Confirmation Times
 </Typography.Title>
 <Typography.Title type='secondary' level={5} style={{ textAlign: 'center', marginBottom: 32 }}>
  A block is sent every minute to calculate Nano confirmation time - updated in real-time.
 </Typography.Title>
      
      <Card size='default' style={{maxWidth: 600, width: '100%'}}>
        <div style={{ display: "flex", textAlign: "justify", gap: 64, flexWrap: "wrap", justifyContent: "center", flexDirection: "row" }}>
          <Statistic
            loading={lastConfTime === null}
            title="Last Block" 
            value={
              (lastConfTime !== null && !isNaN(lastConfTime)) ?
                prettyMilliseconds(lastConfTime)
                : "N/A"
            } 
            precision={0} 
            valueStyle={{
              color: getMsColor(lastConfTime)
            }} 
          />
          <Statistic
            loading={isLoadingAvgDay}
            title="1 Day Avg." 
            value={
              (last7Avg !== null && !isNaN(last7Avg)) ?
                prettyMilliseconds(last1dAvg)
                : "N/A"
            } 
            precision={0} 
            valueStyle={{
              color: getMsColor(last1dAvg)
            }} 
          />
          <Statistic
            loading={isLoadingAvgDay}
            title="7 Day Avg." 
            value={
              (last7Avg !== null && !isNaN(last7Avg)) ?
                prettyMilliseconds(last7Avg)
                : "N/A"
            } 
            precision={0} 
            valueStyle={{
              color: getMsColor(last7Avg)
            }} 
          />
        </div>
      </Card>
      </div>
    </div>
  );
}

export default Home;